import React, { useCallback, useState, memo } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQItem = memo(({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);
  return <div className="border-b border-gray-200 py-4" data-id="element-58">
      <button className="flex justify-between items-center w-full text-left font-medium text-lg text-gray-800" onClick={toggleOpen} data-id="element-59">
        {question}
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-[#438A52]" data-id="element-60" /> : <ChevronDownIcon className="w-5 h-5 text-[#438A52]" data-id="element-61" />}
      </button>
      {isOpen && <div className="mt-3 text-gray-700" data-id="element-62">{answer}</div>}
    </div>;
});
const FAQ = () => {
  const faqs = [{
    question: '¿En qué formato recibiré el ebook?',
    answer: 'Recibirás el ebook en formato PDF, que podrás leer en cualquier dispositivo (computadora, tablet, smartphone). También incluye archivos editables de las listas de compras en formato Excel y Word.'
  }, {
    question: '¿Las recetas son realmente rápidas de preparar?',
    answer: '¡Sí! Todas las recetas están diseñadas para prepararse en 30 minutos o menos. Hemos probado cada receta con mamás ocupadas para asegurarnos que sean realmente prácticas y rápidas.'
  }, {
    question: '¿Necesito ingredientes especiales o difíciles de encontrar?',
    answer: 'No. Todas las recetas utilizan ingredientes comunes que puedes encontrar en cualquier supermercado. Nos enfocamos en ingredientes accesibles y económicos que mantienen la autenticidad de los sabores latinos.'
  }, {
    question: '¿Puedo acceder al contenido desde cualquier dispositivo?',
    answer: 'Sí, una vez realizada tu compra, podrás acceder a todo el contenido desde cualquier dispositivo con conexión a internet. Todos los materiales son descargables para que puedas consultarlos incluso sin conexión.'
  }, {
    question: '¿Cómo funciona la garantía?',
    answer: 'Es simple: si en los primeros 7 días después de tu compra no estás satisfecha con el ebook por cualquier motivo, solo envíanos un email a soporte@lacenaquejesalva.com y te reembolsaremos el 100% de tu dinero. No hay letra pequeña ni condiciones especiales.'
  }, {
    question: '¿Las recetas son adecuadas para niños?',
    answer: '¡Absolutamente! Todas las recetas han sido probadas con familias reales y están diseñadas para agradar tanto a niños como a adultos. Incluimos notas sobre cómo adaptar cada receta para los paladares más exigentes.'
  }];
  const handlePurchaseClick = useCallback(() => {
    // Track purchase intent with Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        value: 7.19,
        currency: 'USD',
        content_name: 'La Cena Que Te Salva'
      });
    }
  }, []);
  return <div className="w-full bg-white py-16" data-id="element-63">
      <div className="container mx-auto px-4" data-id="element-64">
        <div className="text-center mb-12" data-id="element-65">
          <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-66">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-67">
            Todo lo que necesitas saber sobre "La Cena Que Te Salva"
          </p>
        </div>
        <div className="max-w-3xl mx-auto" data-id="element-68">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-69" />)}
        </div>
        <div className="mt-12 text-center" data-id="element-70">
          <h3 className="text-xl font-bold text-gray-800 mb-6" data-id="element-71">
            ¿Tienes más preguntas?
          </h3>
          <p className="text-gray-700 mb-8" data-id="element-72">
            Contáctanos en izytraffic@gmail.com y te responderemos en menos de
            24 horas.
          </p>
          <a href="https://pay.hotmart.com/W102040249E?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#FF6B3C] hover:bg-[#E05A30] text-white font-bold py-3 px-8 rounded-lg text-lg transition duration-300 shadow-lg" onClick={handlePurchaseClick} data-id="element-73">
            ¡Quiero mi copia por solo $7.19!
          </a>
          <p className="mt-3 text-sm text-gray-600" data-id="element-74">
            ¡Oferta por tiempo limitado! Precio normal: $19.99
          </p>
        </div>
      </div>
    </div>;
};
export default memo(FAQ);